/**
 * @typedef {import('tinymce').Editor} Editor
 */

import $ from 'jquery';
import { setFieldValue } from '../util/custom.js';
import { cssAnimation } from '../util/animate-css.js';
import { triggerEvent } from '../util/dom.js';

/**
 * @param {import('./partial-content').PartialContent} partial
 */
export const handleRemoteResponse = (partial) => {

	const pageRequestHandle = mpro.config.page.request_handle;
	const partialRequestHandle = partial.requestHandle;

	// Process the response only if the request matches the current request
	if (partialRequestHandle && (partialRequestHandle !== pageRequestHandle)) {
		console.debug('Response for a different request handle (response request handle: %o, page request handle: %o, partial: %o)', partialRequestHandle, pageRequestHandle, partial);
		// Ignore the response, because it is not for the current request
		return partial;
	}

	// if (partial.requestId && (partial.requestId !== mpro.config.env.request_id)) {
	// 	console.debug('Response for a different request (response request ID: %o, page request ID: %o, partial: %o)', partial.requestId, mpro.config.env.request_id, partial);
	// 	// Ignore the response, because it is not for the current request
	// 	return partial;
	// }

	// Got success/error message
	if (partial.message) {
		// Display the message in a toast
		// @ts-ignore
		const msgType = typeof partial.message;
		mpro.toast(
			// @ts-ignore
			partial.message.format || partial.message.type || (partial.success ? 'success' : 'error'),
			(msgType === 'string')
				? partial.message
				: (msgType === 'object' ? {
					format: (partial.success ? 'success' : 'error'),
					...partial.message,
				} : partial.message.content),
		);
	}

	// Got redirect location
	if (partial.location) {
		// Redirect to new location
		mpro.setLocation(partial.location/* , { replace: true } */);

		// Return early, to prevent further processing
		return partial;
	}

	// Replace page html by selector
	if (partial.pageHtml) {
		for (const [selector, { html, mode = 'replace', animation = true }] of Object.entries(partial.pageHtml)) {

			const $target = $(selector);
			if ($target.length === 0) {
				continue;
			}

			const $content = $(html);

			switch (mode) {
				case 'replace': {
					$target.replaceWith($content);

					break;
				}
				case 'append': {
					$target.append($content);

					break;
				}
				case 'prepend': {
					$target.prepend($content);

					break;
				}
				// No default
			}

			// Wrap the content in a div, to be able to enhance it with js bindings
			// Needs to be done after the replaceWith, because the parent div will have no children
			const $context = $content.wrapAll('<div/>').parent();

			// Enhance the content with js bindings
			mpro.initStatics($context);

			// Unwrap the content
			$content.unwrap('div');

			if (animation) {
				for (const element of $content) {
					cssAnimation(element, 'fadeIn');
				}
			}
		}
	}

	// Reload selector
	if (partial.reload) {
		const $reloadTarget = (partial.reload === true) ? partial.$relatedTarget : $(partial.reload);
		$reloadTarget?.triggerNative('mp-load-fragment');
	}

	// Assign form elements values
	if (partial.formValues) {
		for (const { id, name, selector, value, append } of partial.formValues) {

			/** @type {JQuery<HTMLElement>} */
			let $element;

			if (id) {
				$element = $(`#${id}`);
			}
			else if (name) {
				$element = $(`[name="${name}"]`);
			}
			else if (selector) {
				$element = $(selector);
			}
			else {
				$element = partial.$relatedTarget;
				if ($element.is('input, select, textarea') === false) {
					$element = $element.closest(mpro.config.ui.form_row_selector).find('input, select, textarea').first();
				}
			}

			if (!$element || ($element.length === 0)) {
				console.warn('Element not found for form value assignment (id: %o, name: %o, selector: %o, value: %o, append: %o)', id, name, selector, value, append);
				continue;
			}

			setFieldValue($element, value, append);
		}
	}

	// Open modal
	if (partial.modal) {
		mpro.showModal(partial.modal);
	}

	// Trigger events
	if (partial.triggerEvents) {
		for (const { selector, event, data, bubbles = true, cancelable = true } of partial.triggerEvents) {
			// const $context = selector ? $(selector) : (partial.$relatedTarget?.[0]?.isConnected ? partial.$relatedTarget : partial.$context);
			// It is more logical to use the $context and not the $relatedTarget
			const $context = selector ? $(['document', 'window'].includes(selector) ? window[selector] : selector) : partial.$context;
			// This works also
			// const eventObject = new CustomEvent(event, { bubbles, cancelable: true, detail: data });
			// $context[0].dispatchEvent(eventObject);
			// const eventObject = $.Event(event, { bubbles, cancelable: true, detail: data, data });
			// $context.trigger(eventObject);
			if ($context[0] && $context[0].dispatchEvent) {
				// @ts-ignore
				triggerEvent($context[0], event, { bubbles, cancelable, detail: data, data });
			}
			else {
				console.warn('Cannot trigger event on selector: %o (context: %o, event: %o, data: %o, bubbles: %o, cancelable: %o)', selector, $context[0], event, data, bubbles, cancelable);
			}
		}
	}

	// Trigger a remote-response event
	// ? Better to use the partial.triggerEvents, because it is more flexible
	// triggerEvent(document, 'mp-remote-response', { bubbles: false, cancelable: false, detail: { partial } });

	return partial;
};